<template>
    <div class="contents">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                    <div class="breadcrumb-main user-member justify-content-sm-between">
                        <div class="d-flex flex-wrap justify-content-center breadcrumb-main__wrapper">
                            <div class="d-flex align-items-center user-member__title justify-content-center mr-sm-25">
                                <h4 class="text-capitalize fw-500 breadcrumb-title">🏷️ Label Kontak</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <!-- Form buat/edit label -->
                <div class="col-lg-4">
                    <div class="userDatatable global-shadow border p-30 bg-white radius-xl w-100 mb-30">
                        <h5 class="mb-3">{{ editId ? '✏️ Edit Label' : '➕ Buat Label Baru' }}</h5>
                        <form @submit.prevent="saveLabel">
                            <label>Nama Label</label>
                            <input v-model="form.name" type="text" class="form-control" placeholder="cth: Hot Lead, Minat Kursus A" required maxlength="100">

                            <label class="mt-3">Warna Label</label>
                            <div class="color-grid mt-1">
                                <div v-for="c in presetColors" :key="c"
                                    class="color-dot" :style="{ background: c }"
                                    :class="{ active: form.color === c }" @click="form.color = c"></div>
                            </div>
                            <div class="d-flex align-items-center mt-2">
                                <input v-model="form.color" type="color" class="form-control" style="width:60px;height:38px;padding:2px;">
                                <span class="ml-2 text-muted small">{{ form.color }}</span>
                            </div>

                            <div class="mt-3">
                                <label class="small text-muted">Preview:</label><br>
                                <span class="label-badge" :style="{ background: form.color, color: labelTextColor(form.color) }">{{ form.name || 'Nama Label' }}</span>
                            </div>

                            <div class="button-group d-flex pt-25">
                                <button type="submit" class="btn btn-primary btn-default btn-squared mr-2" :disabled="saving">
                                    {{ saving ? 'Menyimpan...' : (editId ? 'Update' : 'Simpan') }}
                                </button>
                                <button v-if="editId" type="button" class="btn btn-secondary btn-default btn-squared" @click="resetForm">Batal</button>
                            </div>
                        </form>
                    </div>
                </div>

                <!-- Daftar label -->
                <div class="col-lg-8">
                    <div class="userDatatable global-shadow border p-30 bg-white radius-xl w-100 mb-30">
                        <h5 class="mb-3">Daftar Label ({{ labels.length }})</h5>
                        <div v-if="loading" class="text-center text-muted py-3"><i class="fas fa-spinner fa-spin"></i> Memuat...</div>
                        <div v-else-if="labels.length === 0" class="alert alert-info">
                            Belum ada label. Buat label pertama Kakak di sebelah kiri untuk segmentasi kontak 🙏
                        </div>
                        <table v-else class="table table-sm">
                            <thead>
                                <tr><th>Label</th><th>Jumlah Kontak</th><th>Aksi</th></tr>
                            </thead>
                            <tbody>
                                <tr v-for="l in labels" :key="l.id">
                                    <td><span class="label-badge" :style="{ background: l.color, color: labelTextColor(l.color) }">{{ l.name }}</span></td>
                                    <td><span class="badge badge-light">{{ l.contact_count }} kontak</span></td>
                                    <td>
                                        <button class="btn btn-sm btn-info text-white mr-1" @click="startEdit(l)"><i class="fas fa-edit"></i></button>
                                        <button class="btn btn-sm btn-danger" @click="deleteLabel(l)"><i class="fas fa-trash"></i></button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <small class="text-muted d-block mt-2">💡 Setelah buat label, pasang label ke kontak via menu <b>Data Kontak → Edit Kontak</b>.</small>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            labels: [],
            loading: false,
            saving: false,
            editId: null,
            form: { name: "", color: "#e74c3c" },
            presetColors: ["#e74c3c", "#e67e22", "#f1c40f", "#2ecc71", "#1abc9c", "#3498db", "#9b59b6", "#34495e", "#e84393", "#00b894"],
        };
    },
    mounted() {
        this.loadLabels();
    },
    methods: {
        async loadLabels() {
            this.loading = true;
            try {
                const r = await this.$store.dispatch("contact_labels_list");
                this.labels = r.data.data.labels || [];
            } catch (e) {
                this.$toast.error("Gagal memuat label");
            }
            this.loading = false;
        },
        async saveLabel() {
            if (!this.form.name.trim()) return;
            this.saving = true;
            try {
                if (this.editId) {
                    await this.$store.dispatch("contact_labels_update", { id: this.editId, name: this.form.name, color: this.form.color });
                    this.$toast.success("Label diperbarui");
                } else {
                    await this.$store.dispatch("contact_labels_create", { name: this.form.name, color: this.form.color });
                    this.$toast.success("Label dibuat");
                }
                this.resetForm();
                this.loadLabels();
            } catch (e) {
                this.$toast.error((e.response && e.response.data && e.response.data.message) || "Gagal simpan label");
            }
            this.saving = false;
        },
        startEdit(l) {
            this.editId = l.id;
            this.form.name = l.name;
            this.form.color = l.color;
        },
        resetForm() {
            this.editId = null;
            this.form = { name: "", color: "#e74c3c" };
        },
        async deleteLabel(l) {
            if (!confirm('Hapus label "' + l.name + '"? Label akan dilepas dari semua kontak.')) return;
            try {
                await this.$store.dispatch("contact_labels_delete", l.id);
                this.$toast.success("Label dihapus");
                if (this.editId === l.id) this.resetForm();
                this.loadLabels();
            } catch (e) {
                this.$toast.error("Gagal hapus label");
            }
        },
        labelTextColor(hex) {
            if (!hex || typeof hex !== 'string') return '#fff';
            const h = hex.replace('#', '').trim();
            if (h.length < 6) return '#fff';
            const r = parseInt(h.substr(0, 2), 16);
            const g = parseInt(h.substr(2, 2), 16);
            const b = parseInt(h.substr(4, 2), 16);
            // relative luminance — light bg => dark text, dark bg => white text
            const lum = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
            return lum > 0.6 ? '#222' : '#fff';
        },
    },
};
</script>

<style scoped>
.label-badge {
    display: inline-block;
    color: #fff;
    padding: 3px 12px;
    border-radius: 12px;
    font-size: 13px;
    font-weight: 500;
}
.color-grid { display: flex; flex-wrap: wrap; gap: 8px; }
.color-dot {
    width: 28px; height: 28px; border-radius: 50%; cursor: pointer;
    border: 2px solid transparent; transition: all .15s;
}
.color-dot:hover { transform: scale(1.15); }
.color-dot.active { border-color: #333; box-shadow: 0 0 0 2px #fff, 0 0 0 4px #333; }
</style>
